module.exports = __webpack_public_path__ + "img/arrow.a9b031a3.svg";